import { render, staticRenderFns } from "./musteri-personel.vue?vue&type=template&id=45844318"
import script from "./musteri-personel.vue?vue&type=script&lang=js"
export * from "./musteri-personel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports